import React from "react";

import { FaAngleLeft, FaAngleRight} from 'react-icons/fa'

const Arrows = ({ prevArrowOnClickHandler, nextArrowOnclickHandler }) => {
  return (
    <div className="arrows">
      <span className="prevArrow" onClick={prevArrowOnClickHandler}>
        <FaAngleLeft />
      </span>
      <span className="nextArrow" onClick={nextArrowOnclickHandler}>
        <FaAngleRight />
      </span>
    </div>
  );
};

export default Arrows;
